/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITIALSTATE = {};

export default function tripPlanner(state = INITIALSTATE, action) {
    let st = state;

    switch (action.type) {
        case types.GET_TRIP_PLANNER_SEARCH_GEO_RESULTS:
            st = { ...state };
            st.geoResults = action.geoResults;
            st.routePolygon = action.routePolygon;
            st.routePolygonStr = action.routePolygonStr;
            st.routeLine = action.routeLine;
            if (st.geoResults && st.searchLocation) {
                st.geoResults.push(st.searchLocation);
            }
            return st;

        case types.GET_TRIP_PLANNER_DETAILED_ROUTE:
            st = { ...state };
            st.detailedRouteLine = action.routeLine;
            return st;

        case types.GET_TRIP_PLANNER_SEARCH_RESULTS:
            st = { ...state };
            st.listResults[action.index] = action.listResults;
            return st;

        case types.GET_TRIP_PLANNER_SEARCH_ERROR:
            st = { ...state };
            st.error = action.payload;
            return st;

        case types.GET_TRIP_PLANNER_RESET_RESULTS:
            st = {
                geoResults: [],
                listResults: [],
            };
            return st;

        case types.TRIP_PLANNER_SET_SEARCH_LOCATION:
            st = { ...state };
            st.searchLocation = action.searchLocation;
            if (st.geoResults && action.searchLocation) {
                st.geoResults.push(action.searchLocation);
            }
            return st;

        case types.GET_TRIP_INVENTORY_ITEM_DETAILS:
            st = { ...state };
            st.inventoryItemDetails = action.inventoryItemDetails;
            return st;

        default:
            return st;
    }
}
